import * as React from "react";
const SciChartImpl = React.lazy(() => import("./sci-chart-impl"));
/**
 * Lazy loads a chart using the SciChart library.
 *
 * @example
 *
 * ```jsx
 * import { SciChart } from "@skve/components"
 *
 * function Demo() {
 *   return <SciChart />
 * }
 * ```
 */
export const SciChart = (props) => (React.createElement(SciChartImpl, Object.assign({}, props)));
//# sourceMappingURL=sci-chart.js.map